// extracted by mini-css-extract-plugin
export default {"loader":"loader_loader__kvVys","spin":"loader_spin__FUuI7"};